import React, {useRef, useState} from "react";
import {Box, Button, Column, Columns, Control, Field, Modal, Section, Title} from "@allxsmith/bestax-bulma";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";


export default function VehicleChangeModal({open, setOpen, endpoint, vehicleUpdate}){
    const [isLoading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const typeahead = useRef();


    const handleSearch = query => {
        setLoading(true);
        let url = endpoint + `vehiclesearch?search=${query}`;
        axios.get(url).then(resp => {
          setSearchData(resp.data.results);
          setLoading(false);
        });
    };

    const handleContinue = vehicle => {
        typeahead.current.clear();
        vehicleUpdate(vehicle);
        setOpen(false);
    };

    const handleVehicleSelect = e => {
        handleContinue(e[0]);
    };



    return (
        <Modal
            active={open}
            onClose={() => setOpen(false)}
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{ backgroundColor: "grey", height: "400px" }}>
                    <Box>
                        <Columns isMultiline>
                            <Title>Change Vehicle</Title>
                        </Columns>
                        <Columns>
                            <Column>
                                <Field>
                                  <Control>
                                    <AsyncTypeahead
                                      useCache={false}
                                      data-testid="vehicle-search"
                                      id="typeahead"
                                      labelKey="registration"
                                      minLength={2}
                                      name={"registration"}
                                      onSearch={handleSearch}
                                      onChange={handleVehicleSelect}
                                      placeholder={"Search Vehicle Registration"}
                                      options={searchData}
                                      ref={typeahead}
                                      className="registration-ui"
                                      isLoading={isLoading}
                                    />
                                  </Control>
                                </Field>
                            </Column>
                            <Column>
                                <Button
                                    color={"info"}
                                    onClick={() => setOpen(false)}
                                    isFullWidth
                                >
                                    Close
                                </Button>
                            </Column>
                        </Columns>
                    </Box>
                </Section>
            </Modal.Content>
        </Modal>
    )

}